export const boardKeys = {
  all: ["board"] as const,
  workstreams: () => [...boardKeys.all, "workstreams"] as const,
  milestones: () => [...boardKeys.all, "milestones"] as const,
  components: () => [...boardKeys.all, "components"] as const,
  dependencies: () => [...boardKeys.all, "dependencies"] as const,
  features: () => [...boardKeys.all, "features"] as const,
  feature: (id: string) => [...boardKeys.all, "feature", id] as const,
  featureDependencies: () => [...boardKeys.all, "feature-dependencies"] as const,
  // Activity / audit log. featureActivity nests under activity so invalidating
  // activity() refreshes both the board-level feed and every per-item feed.
  activity: () => [...boardKeys.all, "activity"] as const,
  featureActivity: (id: string) => [...boardKeys.all, "activity", id] as const,
};
